const config = {
  env: 'local',
  apiUrl: "https://api.astrothirdeye.com/api",
}

export default config;